import classNames from 'classnames';
import React from 'react';
import './index.scss';

interface EfSpecProps {
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 间隔组件（要放到容器ID里面，标题上方）
 * 这是跟设计统一规范后的值
 * > 1024 为 180px
 * [768, 1024] 为 130px
 * < 768 为 110px
 */
const EfSpec: React.FC<EfSpecProps> = ({ className }: EfSpecProps) => {
    const prefixCls = `ef-spec`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    return <div className={classes}></div>;
};

export default EfSpec;
